var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61523 8.80814C1.61523 5.90719 1.61523 4.45672 2.51644 3.55551C3.41765 2.6543 4.86813 2.6543 7.76908 2.6543H10.846C13.747 2.6543 15.1974 2.6543 16.0986 3.55551C16.9998 4.45672 16.9998 5.90719 16.9998 8.80814V10.3466C16.9998 13.2476 16.9998 14.698 16.0986 15.5992C15.1974 16.5005 13.747 16.5005 10.846 16.5005H7.76908C4.86813 16.5005 3.41765 16.5005 2.51644 15.5992C1.61523 14.698 1.61523 13.2476 1.61523 10.3466V8.80814Z",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46143 2.65385V1.5",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1538 2.65385V1.5",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.5H16.6154",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.66ce4aead34dbb389679d075153d68d1.svg";
export { ForwardRef as ReactComponent };